<div class="w-screen h-screen pt-3 static flex flex-col overflow-x-hidden overflow-y-scroll main-scroll" [class]="backgroundColor()"
     style="scrollbar-width: none">

  <app-navbar id="navbar" class="xs:h-20 sm:h-20 md:h-20 fixed left-0 right-0 md:right-0 top-0 z-9999" [class]="navBarColor()" />
  <router-outlet />

  <div *ngIf="scrolling && !window?.location?.pathname?.includes('subscribe-v2') && !window?.location?.pathname?.includes('meeting-profiles')"
       class="fixed right-5 bottom-5 w-15 h-15 bg-theme-black rounded-full z-9998 cursor-pointer" (click)="scrollToTop()">
    <p class="text-white text-3xl w-full text-center leading-[60px]"><i class="fa-solid fa-chevron-up"></i></p>
  </div>
</div>



